import { TransactionDetails } from '@verantos-dev/types-common';

export enum CohortCharacteristicsResultType {
  ETHNICITY = 'ethnicity',
  GENDER = 'gender',
  RACE = 'race',
  AGE_AT_INDEX = 'ageAtIndex',
}

export type CohortSummaryAttributeResult = {
  attributeName: string;
  attributeCount: number;
  attributePercentage: number;
};

export type CohortCharacteristicsResults = {
  [key in CohortCharacteristicsResultType]: CohortSummaryAttributeResult[];
};

export interface CohortSummaryDetails extends TransactionDetails, CohortCharacteristicsResults {
  cohortDefinitionId: string;
}
